import _get from 'lodash/get';
import { orderManagementState } from '../selectors';

const returnProcessingState = state => _get(orderManagementState(state), 'returns');
export const returnFeed = state => _get(returnProcessingState(state), 'returnFeed');
export const getData = state => _get(returnFeed(state), 'data');
export const getReturnsData = state => _get(getData(state), 'returns');
export const selectReturnData = state => _get(returnFeed(state), 'returnData');
export const selectShowAddNewReturnModal = state => 
    _get(returnFeed(state), 'showAddNewReturnModal');
export const getReturnsTotalRecords = state => 
  _get(getData(state), 'totalRecords');
export const getReturnsPage = state => _get(getData(state), 'page');
export const getReturnsItemsPerPage = state => 
  _get(getData(state), 'itemsPerPage');
export const getLastPage = state => _get(returnFeed(state), 'lastPage');
export const getFilters = state => _get(returnFeed(state), 'filters');
export const selectOrderLine = state => _get(returnFeed(state), 'orderLine');
export const getShowOptionsModal = state => _get(returnFeed(state), 'showOptionsModal');
export const getIsRefreshing = state => _get(returnFeed(state), 'isRefreshing');
export const getIsExporting = state => _get(returnFeed(state), 'isExporting');
export const getIsFetchingFeed = state => _get(returnFeed(state), 'isFetchingFeed');


// settings
const settingsState = state => _get(returnProcessingState(state), 'settings');
export const getSettingsColumnsOrder = state => _get(settingsState(state), 'columnsOrder');
export const getSettingsColumns = state => _get(settingsState(state), 'columns');
export const getSettingsItemsPerPage = state => _get(settingsState(state), 'itemsPerPage');
export const getSettingsSorting = state => _get(settingsState(state), 'sorting');


// Config
export const configState = state => _get(returnProcessingState(state), 'config');
export const selectFilterOptions = state => _get(configState(state), 'filterOptions');
export const selectColumnFilterOptions = state => _get(configState(state), 'columnFilterOptions');
export const selectQuickFilterOptions = state => _get(configState(state), 'quickFilterOptions');

